import request from '@/utils/request'

const getRefund = (page, limit) => {
  return request({
    url: '/api/refund',
    method: 'post',
    data: {
      page: page,
      limit: limit
    }
  })
}
const checkRefundBonus = () => {
  return request({
    url: '/api/refund/check',
    method: 'get'
  })
}

const receviedRefundBonus = () => {
  return request({
    url: '/api/refund/receive',
    method: 'get'
  })
}

const addRefundToWallet = () => {
  return request({
    url: '/api/refund/addWallet',
    method: 'get'
  })
}

const getRefundBanner = () => {
  return request({
    url: '/api/refund/banners',
    method: 'get'
  })
}

export default {
  getRefund,
  checkRefundBonus,
  receviedRefundBonus,
  addRefundToWallet,
  getRefundBanner
}
